import { ReactNode } from 'react';

export interface CommonProps {
    customClass?: string;
    containerTitle: ReactNode;
    keyHeader: ReactNode;
    valueHeader: ReactNode;
    data: { [key: string]: string | null } | null;
    extraData?: { [key: string]: string | null }[] | null;
}

export const CommonContainer = (props: CommonProps) => {
    return (
        <div
            className={
                props.customClass
                    ? props.customClass
                    : 'bg-background-surface outline-border-default inline-flex flex-1 flex-col items-start justify-start gap-6 rounded-xl py-4 outline-1 outline-offset-[-1px]'
            }>
            <div className='inline-flex items-center justify-start self-stretch px-4'>
                <div className='text-foreground-default justify-start text-xl font-semibold'>{props.containerTitle}</div>
            </div>
            <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                <div className='flex flex-col items-start justify-start self-stretch'>
                    <div className='border-border-default inline-flex items-start justify-start gap-6 self-stretch border-b px-4 py-3'>
                        <div className='text-foreground-default w-64 justify-start text-base font-medium'>{props.keyHeader}</div>
                        <div className='text-foreground-default flex-1 justify-start text-base font-medium'>{props.valueHeader}</div>
                    </div>
                    {props.data &&
                        Object.entries(props.data).map(([key, value], index) => {
                            const entries = Object.entries(props.data!);
                            const isLastItem = index === entries.length - 1;
                            return (
                                <div
                                    key={`${key}-${index}`}
                                    className={`bg-background-surface h-11 self-stretch border-r border-l px-4 py-3 ${isLastItem ? '' : 'border-b'} border-border-default inline-flex items-center justify-start gap-6`}>
                                    <div className='flex w-64 items-start justify-start gap-2.5'>
                                        <div className='text-foreground-default justify-start text-sm font-medium'>{key}</div>
                                    </div>
                                    <div className='flex flex-1 items-start justify-start gap-2.5'>
                                        <div className='text-foreground-default justify-start text-sm font-medium'>{value}</div>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
            {props.extraData &&
                props.extraData.length > 0 &&
                props.extraData.map((data, index) => (
                    <div
                        className='flex flex-col items-start justify-start gap-3 self-stretch'
                        key={index}>
                        <div className='flex flex-col items-start justify-start self-stretch'>
                            <div className='border-border-default inline-flex items-start justify-start gap-6 self-stretch border-b px-4 py-3'>
                                <div className='text-foreground-default w-64 justify-start text-base font-medium'>{props.keyHeader}</div>
                                <div className='text-foreground-default flex-1 justify-start text-base font-medium'>{props.valueHeader}</div>
                            </div>
                            {data &&
                                Object.entries(data).map(([key, value], index) => {
                                    const entries = Object.entries(data);
                                    const isLastItem = index === entries.length - 1;
                                    return (
                                        <div
                                            key={`${key}-${index}`}
                                            className={`bg-background-surface h-11 self-stretch border-r border-l px-4 py-3 ${isLastItem ? '' : 'border-b'} border-border-default inline-flex items-center justify-start gap-6`}>
                                            <div className='flex w-64 items-start justify-start gap-2.5'>
                                                <div className='text-foreground-default justify-start text-sm font-medium'>{key}</div>
                                            </div>
                                            <div className='flex flex-1 items-start justify-start gap-2.5'>
                                                <div className='text-foreground-default justify-start text-sm font-medium'>{value}</div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                ))}
        </div>
    );
};
